import angular from 'angular';

module.exports = angular.module('common.filters.tel-href', [])
.filter('telhref', function () {
  return function(value) {
    if (!value) return '';

    var number = value.toString().trim().replace(/\D/g, '');
    if (number[0] !== '1') number = '1' + number;
    return 'tel://' + number;
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/tel-href.js
 **/